export const getSnackbarOpenFields = (state, message, severity) => ({ ...state, snackbar: { ...state.snackbar, message, severity, open: true } });
